export const getInsiderAnalysisCategories = state =>
  state.insiderAnalysisCategories.data;
export const getInsiderAnalysisCategoriesLoading = state =>
  state.insiderAnalysisCategories.loading;
